import {Injectable} from "@angular/core";
import {Http, Response} from '@angular/http';
import {Observable} from "rxjs";

import { AuthService } from '../../auth/auth.service';
import {environment} from '../../../environments/environment';


@Injectable()
export class BookSendService {

  defaultTemplate =
    '<div style="width: 80%; margin: 20px auto; background-color: white; border: 5px solid #fff; box-shadow: 5px 5px 5px 5px #ccc;float: left">' +
    '<div style="width: 100%; height: 50px; text-align: center; display: block; background-color: #970c24;">' +
    '<img src="https://www.libreriaamericalatina.com/assets/images/shared/no-book.jpg" style="max-height: 100%">' +
    '</div>';
  body = {
    "substitution_data": {
    },
    "recipients": [],
    "content": {
      "from": "sistema@libreriaamericalatina.com",
      "subject": "",
      "html": "",
      "attachments": []
    }

  };

  constructor(private http: Http, private authService: AuthService){}

  sendMail(subject?: string, textBody: string = '', html?: string, recipients?: string[]): Observable<Response> {
    recipients.map(recipient => {
      this.body.recipients.push({
        "address": recipient['email']
      });
    });
    const toSend = textBody? textBody : '';
    this.body.content.html = this.defaultTemplate + toSend + html + '</div>';
    this.body.content.subject = subject? subject : 'Catálogo novedades';
    const options = this.authService.addAuthToken();
    const path = `${environment.alApiUrl}/SparkPost/Send`;
    return this.http.post(path, this.body, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/book/book-send/book-send.service.ts